import { createElement } from 'react';
import Base from './components/base';
import './index.less';
const IndicatorBase = (props) => {
    return createElement(Base, { ...props });
};
export default IndicatorBase;
